import { Environment } from '@abp/ng.core';

const baseUrl = 'https://gcm-dev.gip-us.com';

const oAuthConfig = {
  issuer: 'https://gipcm-dev.azurewebsites.net/',
  redirectUri: baseUrl,
  clientId: 'GCM_App',
  responseType: 'code',
  scope: 'offline_access openid profile email GCM',
  requireHttps: true,
};

export const environment = {
  label: 'QA',
  production: false,
  application: {
    baseUrl,
    name: 'GCM',
  },
  oAuthConfig,
  apis: {
    default: {
      url: oAuthConfig.issuer,
      rootNamespace: 'GIP.CM',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  remoteEnv: {
    url: '/getEnvConfig',
    mergeStrategy: 'deepmerge'
  },
  instrumentationKey: '1be33964-7a9d-4a0e-ab7f-31bf8989d212',
  efileAgent: {
    healthUrl: 'https://127.0.0.1:47821/health',
    runUrl: 'https://127.0.0.1:47821/run-efile',
    showTestColumn: true,
  },
} as Environment;
